/* istanbul ignore file */

import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

const LoadingState = ({ className, isOpaque }) => (
  <div className={ClassNames('LoadingState', className, { 'LoadingState--isOpaque': isOpaque })}>
    <div className="LoadingState__spinner" />
    <style jsx>
      {`
        .LoadingState {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-color: rgba(255, 255, 255, 0.95);
          z-index: 2;
        }

        .LoadingState--isOpaque {
          background-color: rgba(255, 255, 255, 1);
        }

        @keyframes spinner {
          to {
            transform: rotate(360deg);
          }
        }

        .LoadingState__spinner:before {
          content: '';
          box-sizing: border-box;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 20px;
          height: 20px;
          margin-top: -10px;
          margin-left: -10px;
          border-radius: 50%;
          border: 2px solid ${Theme.get('colors-grey')};
          border-top-color: ${Theme.get('colors-black')};
          animation: spinner 0.6s linear infinite;
        }
      `}
    </style>
  </div>
);

LoadingState.propTypes = {
  className: PropTypes.string,
  isOpaque: PropTypes.bool,
};

LoadingState.defaultProps = {
  className: null,
  isOpaque: false,
};

export default LoadingState;
